import React from 'react'
import { AddCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import TextField from '../../../../../atoms/TextField'

import useStyles from './styles'

export type NewTaskInputProps = {
  canEdit: boolean
  showInput: boolean
  setShowInput: React.Dispatch<React.SetStateAction<boolean>>
  subtaskTitle: string
  setSubtaskTitle: React.Dispatch<React.SetStateAction<string>>
  handleFields: CallableFunction
  delayUpload: () => void
}

const NewTaskInput: React.FC<NewTaskInputProps> = ({
  canEdit,
  showInput,
  setShowInput,
  subtaskTitle,
  setSubtaskTitle,
  handleFields,
  delayUpload
}) => {
  const classes = useStyles()
  const theme = useTheme()

  if (!canEdit) {
    return null
  }

  if (!showInput) {
    return (
      <div onClick={() => setShowInput(true)} className={classes.button}>
        <AddCircle size={theme.size.base} className={classes.icon} />
        Add Subtask
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <TextField
        autoFocus
        placeholder='Add subtask'
        value={subtaskTitle || ''}
        onChange={e => setSubtaskTitle(e.target.value)}
        className={classes.transparent}
        onKeyDown={e => handleFields(e, 'subtasks')}
        onBlur={() => delayUpload()}
        disabled={!canEdit}
      />
    </div>
  )
}

export default NewTaskInput
